import createTsdApi from "../../../client-api/createTsdApi";
import {
  IdCard,
  IdCardCreateParams,
  IdCardQueryParams,
  IdCardUpdateParams,
} from "../../../entities/IdCard/idCard";
import tsdFetch, { TsdSearchParam } from "../fetch";

const idCardApi = createTsdApi<
  IdCard,
  IdCardQueryParams,
  IdCardCreateParams,
  IdCardUpdateParams
>("id-cards", (params) => {
  const search: TsdSearchParam<IdCardQueryParams>[] = [];

  ({
    ids: (() => {
      if (typeof params.ids !== "undefined") {
        params.ids.forEach((id) =>
          search.push({ key: "ids", value: String(id) })
        );
      }
    })(),
    limit: (() => {
      if (typeof params.limit !== "undefined") {
        search.push({
          key: "limit",
          value: String(params.limit),
        });
      }
    })(),
    offset: (() => {
      if (typeof params.offset !== "undefined") {
        search.push({
          key: "offset",
          value: String(params.offset),
        });
      }
    })(),
    customerIds: (() => {
      if (typeof params.customerIds !== "undefined") {
        params.customerIds.forEach((id) =>
          search.push({ key: "customerIds", value: String(id) })
        );
      }
    })(),
    isDeleted: (() => {
      if (typeof params.isDeleted !== "undefined") {
        search.push({
          key: "isDeleted",
          value: params.isDeleted ? "1" : "0",
        });
      }
    })(),
    deletedAtGte: (() => {
      if (typeof params.deletedAtGte !== "undefined") {
        search.push({
          key: "deletedAtGte",
          value: params.deletedAtGte,
        });
      }
    })(),
    createdLte: (() => {
      if (typeof params.createdLte !== "undefined") {
        search.push({
          key: "createdLte",
          value: params.createdLte,
        });
      }
    })(),
    isErased: (() => {
      if (typeof params.isErased !== "undefined") {
        search.push({ key: "isErased", value: params.isErased ? "1" : "0" });
      }
    })(),
  }) satisfies {
    [key in keyof Required<IdCardQueryParams>]: void | undefined;
  };

  return search;
});

const create = async (fields: IdCardCreateParams) => {
  const formData = new FormData();

  formData.append("idCardTemplateId", String(fields.idCardTemplateId));
  formData.append("customerId", String(fields.customerId));
  formData.append("previewUploadImageFile", fields.previewUploadImageFile);

  if (typeof fields.nickname !== "undefined") {
    formData.append("nickname", fields.nickname);
  }

  const url = `/api/v1/id-cards`;
  return tsdFetch<IdCard, IdCardQueryParams>(url, {
    method: "POST",
    body: formData,
  });
};

export default {
  get: idCardApi.get,
  getOne: idCardApi.getOne,
  create,
  update: idCardApi.update,
  delete: idCardApi.delete,
};
